import React from 'react';

import { toast } from 'react-toastify';
import { ExperimentOutlined } from '@ant-design/icons';
import { Observer, isQueryGroup } from 'src/interfaces/entities/observer';
import { useForceObserverExecutionMutation } from 'src/redux/services/centralApi';
import { Button, Tooltip } from 'antd';

export default function ForceExecution({ row, }: { row: Observer }) {

	const [ forceExecution, forceExecutionResult, ] = useForceObserverExecutionMutation();

	return (
		<Tooltip title="Forçar execução">
			<Button
				type="text"
				loading={forceExecutionResult.isLoading}
				icon={<ExperimentOutlined />}
				onClick={() => {
					forceExecution(row.observer_id)
						.unwrap()
						.then(({ payload, }) => {
							if (isQueryGroup(row)) {
								if (payload.execution_ok === true) {
									toast.success('Grupo de consultas executado! O envio segue para os grupos.', {
										autoClose: 1000,
									});
								} else {
									toast.error('Não foi possível executar o grupo de consultas.');
								}
							} else if (payload.execution_ok === true) {
								toast.success('Observador executado! Sem ocorrência!', {
									autoClose: 1000,
								});
							} else {
								toast.success('Observador executado! Gerou ocorrência!', {
									autoClose: 1000,
								});
							}

						})
						.catch((err) => {
							if (err?.status && err?.status === 500
                    && err?.data?.frontend_message) {
								toast.error(err?.data?.frontend_message, {
									autoClose: 1000,
								});
							}
						});
				}}
			/>
		</Tooltip>
	);
}
